import React from "react";
import * as styles from "./MenuItemHeadline.module.scss";


function MenuItemHeadline({moreLinkHref, moreLinkText = "View all", children}) {
  return (
    <div className={styles.root}>
      <div className={styles.textWrap}>{children}</div>
      {moreLinkHref && (
        <a className={styles.moreLink} href={moreLinkHref}>
          {moreLinkText}&nbsp;&rarr;
        </a>
      )}
    </div>
  );
}

export default MenuItemHeadline;
